<template>
  <div>
    <header>
      <nav>
        <ul>
          <li>
            <a class="link-bio" @click="goHome">Bio</a>
          </li>
          <li>
            <a class="link-projects" @click="goProjects">Projects</a>
          </li>
          <li>
            <a class="link-find-me" @click="goFindMe">Find Me</a>
          </li>
        </ul>
      </nav>
    </header>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg: null,
    };
  },
  methods: {
    goHome() {
      this.$router.push({ name: "Home" });
      this.bg === "bio";
    },
    goProjects() {
      this.$router.push({ name: "Projects" });
      this.bg === "projects";
    },
    goFindMe() {
      this.$router.push({ name: "FindMe" });
      this.bg === "findMe";
    },
  },
};
</script>

<style lang="scss" scoped>
nav {
  margin-left: 100px;
  position: fixed;
  top: var(--border-width);
  left: var(--border-width);
  z-index: 20;
}
nav ul {
  list-style: none;
  display: flex;
  text-align: center;
  margin: 0;
  padding: 0;
}
nav li {
  flex: 1 0 7.5rem;
}
nav a {
  display: block;
  padding: 0.5rem 0 0.5rem;
  color: var(--secondary-color);
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-size: 0.875rem;
  cursor: pointer;
}
nav .link-projects {
  color: var(--primary-color);
}

// Adaptives
@media only screen and (max-width: 64em) {
  nav {
    margin: 0;
    top: 0;
    left: 0;
  }
}
@media only screen and (max-width: 30em) {
  nav {
    position: relative;
    text-align: center;
  }
  nav li {
    flex: 0.5rem;
  }
  nav a {
    padding: 0.7rem 0.5rem;
    font-size: 0.7rem;
    letter-spacing: 1px;
  }
}
@media only screen and (min-width: 64em) {
  nav a {
    padding: 1rem 1rem;
    font-size: 1rem;
  }
}
// End Adaptives
</style>
